<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { inject, onMounted } from 'vue'
import { getPodmienkyData } from './utils'
import {
  VyzvaSpecificationPublicResponse,
  ZoppmPodmienkaSpecRefTypEnum,
} from '/@src/client-public'
export interface FyzickaOsobaProps {}

const props = defineProps<FyzickaOsobaProps>()
const { t } = useI18n()

const specResponse = inject('specResponse') as VyzvaSpecificationPublicResponse

const specRefName =
  ZoppmPodmienkaSpecRefTypEnum['InePodmienkyPoskytnutiaProstriedkovMechanizmu'] ||
  ZoppmPodmienkaSpecRefTypEnum['DalsiePodmienkyPoskytnutiaProstriedkovMechanizmu']
const podmienky = specResponse!.zoppmSpec!.podmienky!

const [podmienkyData, position] = getPodmienkyData(podmienky, specRefName)

onMounted(() => {})
</script>

<template>
  <template v-if="podmienkyData?.zoppmPodmienkaSpecRef?.zoppmPodmienkaSpecId">
    <PodmienkyPoskytnutia
      :data="podmienkyData"
      :array-position="position"
      :spec-ref-name="specRefName"
      :title="t('zoppm.step2.ZoppmSsPodmienkyDalsie')"
    />
  </template>
</template>

<style lang="scss"></style>
